import { render } from "./BodyComponent.vue?vue&type=template&id=fc749bb8&scoped=true&ts=true"
import script from "./BodyComponent.vue?vue&type=script&lang=ts"
export * from "./BodyComponent.vue?vue&type=script&lang=ts"

import "./BodyComponent.vue?vue&type=style&index=0&id=fc749bb8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.21_vue@3.4.21_typescript@5.4.5__webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc749bb8"]])

export default __exports__